import React from 'react';

// Import SVGs as React components
import { ReactComponent as MapPinIcon } from '../assets/svgs/map-pin.icon.svg';
import { ReactComponent as MagnifierIcon } from '../assets/svgs/magnifier.icon.svg';
import { ReactComponent as SortIcon } from '../assets/svgs/sort.icon.svg';

type IconName = 'map-pin' | 'magnifier' | 'sort';

interface IconSwitchProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
}

const icons: Record<IconName, React.FC<React.SVGProps<SVGSVGElement>>> = {
  'map-pin': MapPinIcon,
  'magnifier': MagnifierIcon,
  'sort': SortIcon,
//   'alert': AlertIcon,
//   'offline': OfflineIcon,
};

const IconSwitch: React.FC<IconSwitchProps> = ({ name, ...props }) => {
  const IconComponent = icons[name];
  return IconComponent ? <IconComponent {...props} /> : null;
};

export default IconSwitch;
